
// 中文配置
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { defineComponent, ref } from "vue";
// andt图标
import * as AntdIcon from "@ant-design/icons-vue";
// alp-UA图标
import alpIcon from "../icons/icon.vue";
// 多行文本输入
import alpMultiText from "../alp-multiText/multiText.vue";

// 类型检测
function typeString(obj) {
  var str = Object.prototype.toString.call(obj).replace(/[\[\]]/g, "");
  return str.split(" ")[1];
}

interface selOption {
  key: string | number;
  value: string | number;
  disabled: boolean;
}

interface formItem {
  label: string;
  span: number;
  offset: number;
  soltName: string;
  colHeight: number;
  hidden: boolean;
  name: string;
  value: any;
  type: string;
  options: Array<any>;
  updatekey: number;
  getOptions: any;
  format: string;
  rule: Array<any>;
  change: any;
  blur: any;
  class: String;
  a_attr: any;
  a_event: any;
  disabled: any;
  placeholder: String;
  showTime: String;
  startFun: any;
  startName: any;
  startPlaceholder: any;
  endName: any;
  endFun: any;
  endPlaceholder: any;
  spacer: any;
  suffix: any;
  maxLimit: any;
}

export default defineComponent({
  name: "alpFormGroup",
  props: {
    options: Object,
    form_data: Object,
    getDict: Function,
  },
  components: {
    alpIcon,
    alpMultiText,
  },
  setup: function () {
    return {
      zhCN,
    };
  },
  data: function () {
    return {
      // 表单标题
      formTitle: "",
      titleShow: true,
      // 表单配置
      formConfg: {
        labelAlign: "left", // label对齐方式 left|right,
        layout: "horizontal", // 表单布局 'horizontal'|'vertical'|'inline'
        hideRequiredMark: false, // 是否隐藏必选标记
        // labelCol: {},
        // wrapperCol: {},
        colon: true, // layout = horizontal 有效 label后是否有冒号
        gutter: 10, // 表单块间隔
        // name: "", // 表单保存对象
        a_attr: {},
        a_event: {},
      },
      // 表单项
      form: <Array<formItem>>[],
      // 表单数据对象
      formData: {},
      // 表单数据验证规则
      formRules: {},
    };
  },
  methods: {
    // 表单分组初始化
    init: function (options) {
      // console.log(options)
      // 表单配置
      this.formTitle = options.formTitle;
      this.titleShow = options.titleShow ? true : false;

      this.formConfg.layout = options.layout;
      this.formConfg.labelAlign = options.labelAlign;
      this.formConfg.hideRequiredMark = options.hideRequiredMark;
      // this.formConfg.labelCol = options.labelCol;
      // this.formConfg.wrapperCol = options.wrapperCol;
      this.formConfg.a_attr = Object.assign({}, options.a_attr);
      this.formConfg.a_event = Object.assign({}, options.a_event);
      this.formConfg.colon = options.colon;
      this.formConfg.gutter = options.gutter;
      // this.formConfg.name = options.name;

      // 表单项
      var form = <Array<formItem>>[],
        rules = <any>{};
      options.form.forEach((one) => {
        if (one.name) {
          this.formData[one.name] = one.value;
        }
        var template = {
          ...one,
          updatekey: 1,
        };
        // 初始化表单数据
        var that = <any>this;
        if (that.form_data && one.name && that.form_data[one.name]) {
          if (that.form_data[one.name].hasOwnProperty("value")) {
            // 默认值
            that.formData[one.name] = that.form_data[one.name].value;
          }
          if (that.form_data[one.name].hasOwnProperty("disabled")) {
            // 禁用
            template.disabled = that.form_data[one.name].disabled;
          }
          // 获取表单项
          if (that.form_data[one.name].hasOwnProperty("options")) {
            // 默认值
            template.options = that.form_data[one.name].options;
          }
          // 获取表单项  字典项key
          if (that.form_data[one.name].hasOwnProperty("dictKey")) {
            template.dictKey = that.form_data[one.name].dictKey;
          }
          // 获取表单项  延时回调方法
          if (that.form_data[one.name].hasOwnProperty("getOptions")) {
            // 默认值
            template.getOptions = that.form_data[one.name].getOptions;
          }
          // 获取表单项  延时回调方法
          if (that.form_data[one.name].hasOwnProperty("change")) {
            // 默认值
            template.change = that.form_data[one.name].change;
          }
          // 获取表单项  延时回调方法
          if (
            that.form_data[one.name].hasOwnProperty("suffixClick") &&
            template.suffix
          ) {
            // 默认值
            template.suffix.click = that.form_data[one.name].suffixClick;
          }
        }

        // select/treeSelect   选项懒加载
        if (
          ["select", "treeSelect", "radioGroup", "checkboxGroup"].indexOf(
            template.type
          ) != -1
        ) {
          if (template.getOptions) {
            template.options = ref([]);
            (function (template, formData) {
              var res = template.getOptions(formData);
              if (typeString(res) == "Promise") {
                res.then((resP) => {
                  template.options.value = resP;
                  template.updatekey++;
                });
              }
            })(template, {
              // 全部表单项
              form: that.form,
              // 全部表单内容
              formData: that.formData,
              // 全部表单验证规则
              formRules: that.formRules,
            });
          } else if (template.dictKey) {
            template.options = ref([]);
            (function (template) {
              var res =
                typeString(that.getDict) === "Function" &&
                that.getDict(template.dictKey);
              if (typeString(res) == "Promise") {
                res.then((resP) => {
                  template.options.value = resP;
                  template.updatekey++;
                });
              }
            })(template);
          }
        }
        form.push(template);
        rules[one.name] = one.rule;
      });
      form.forEach((one) => {
        if (one.type === "datePicker") {
          this.formData[one["startName"]] = one["startValue"];
          this.formData[one["endName"]] = one["endValue"];
          //设置日期范围控制
          one["startFun"] = (start) => {
            if (!start || !this.formData[one["endName"]]) {
              return false;
            }
            var enddate = new Date(this.formData[one["endName"]]);
            return start.valueOf() > enddate.valueOf();
          };
          //
          one["endFun"] = (end) => {
            if (!end || !this.formData[one["startName"]]) {
              return false;
            }
            var startdate = new Date(this.formData[one["startName"]]);
            return startdate.valueOf() >= end.valueOf();
          };
        }
        //添加禁用
        if (typeString(one["disabled"]) === "Function") {
          one["disabled"] = one["disabled"](this.formData);
        }
        //修改select类型值为字符串
        if (one.type === "select") {
          var typeMap = ["[object Undefined]", "[object Null]"];
          if (Array.isArray(this.formData[one.name])) {
            this.formData[one.name].forEach((o, i) => {
              var oTypeStr = Object.prototype.toString.call(o);
              this.formData[one.name][i] =
                typeMap.indexOf(oTypeStr) != -1 ? undefined : "" + o;
            });
          } else {
            var typeStr = Object.prototype.toString.call(
              this.formData[one.name]
            );
            this.formData[one.name] =
              typeMap.indexOf(typeStr) != -1
                ? undefined
                : "" + this.formData[one.name];
          }
          // console.log((this.formData[one.name] !== undefined && this.formData[one.name] !== null),6000);
          // (this.formData[one.name] !== undefined && this.formData[one.name] !== null)
          //   ? this.formData[one.name].toString()
          //   : this.formData[one.name];
        }
      });
      this.form = form;
      this.formRules = rules;
    },
    // 动态加载icon
    dynamicIcon: function (icon) {
      // console.log(icon);
      return AntdIcon[icon] || "";
    },
    dynamicAlpIcon: function (icon) {
      // console.log(icon);
      return icon.split(":")[1];
    },
    //获取select配置
    getDicts(options) {
      // 表单项
      var form = <Array<formItem>>[],
        rules = <any>{};
      let formData = JSON.parse(JSON.stringify(this.formData));
      for (const key in formData) {
        this.formData[key] = formData[key];
      }
      options.form.forEach((one) => {
        var template = {
          ...one,
          updatekey: 1,
        };
        // 初始化表单数据
        var that = <any>this;
        if (
          ["select", "treeSelect", "radioGroup", "checkboxGroup"].indexOf(
            template.type
          ) != -1
        ) {
          if (template.getOptions) {
            template.options = ref([]);
            (function (template, formData) {
              var res = template.getOptions(formData);
              if (typeString(res) == "Promise") {
                res.then((resP) => {
                  template.options.value = resP;
                  template.updatekey++;
                });
              }
            })(template, {
              // 全部表单项
              form: that.form,
              // 全部表单验证规则
              formRules: that.formRules,
            });
          } else if (template.dictKey) {
            template.options = ref([]);
            (function (template) {
              var res =
                typeString(that.getDict) === "Function" &&
                that.getDict(template.dictKey);
              if (typeString(res) == "Promise") {
                res.then((resP) => {
                  template.options.value = resP;
                  template.updatekey++;
                });
              }
            })(template);
          }
        }
        form.push(template);
        rules[one.name] = one.rule;
      });
      this.form = form;
      this.formRules = rules;
    },
    // 变更回调
    formItemChange: function (data, item) {
      // console.log(data, item, this.formData);
      if (typeof item.change == "function") {
        item.change({
          // 变化后数据
          value: data,
          // 当前表单项
          formItem: item,
          // 全部表单项
          form: this.form,
          // 全部表单内容
          formData: this.formData,
          // 全部表单验证规则
          formRules: this.formRules,
        });
      }
    },
    // 后缀点击按钮
    suffixClick: function (data, item) {
      this.resetValidation("validate");
      if (item.suffix && typeof item.suffix.click == "function") {
        item.suffix.click({
          // 变化后数据
          value: data,
          // 当前表单项
          formItem: item,
          // 全部表单项
          form: this.form,
          // 全部表单内容
          formData: this.formData,
          // 全部表单验证规则
          formRules: this.formRules,
        });
      }
    },
    // 获取表单数据
    getFormData: function () {
      return {
        // 全部表单项
        form: this.form,
        // 全部表单内容
        formData: this.formData,
        // 全部表单验证规则
        formRules: this.formRules,
      };
    },
    // 获取单一表单项
    getSingleData: function (key) {
      if (key && this.formData[key]) {
        return {
          formData: this.formData[key],
          formRules: this.formRules[key],
        };
      }
    },
    // 设置单一表单项
    setSingleData: function (key, value) {
      if (key) {
        return (this.formData[key] = value);
      }
    },
    // 表单验证
    formValidation: function (params) {
      return new Promise((resolve) => {
        var form = <any>this.$refs["formRef"];
        form
          .validate(params)
          .then((res) => {
            // console.log(res);
            // 验证通过
            resolve({
              state: true,
              form: res,
            });
          })
          .catch((err) => {
            // 验证失败
            resolve({
              state: false,
              form: err,
            });
          });
      });
    },
    // 重置表单/取消验证 type validate只取消验证规则   不传 重置表单
    resetValidation: function (type: string) {
      var form = <any>this.$refs["formRef"];
      if (type == "validate") {
        form.clearValidate();
      } else {
        form.resetFields();
        for (let key in this.formData) {
          this.formData[key] = undefined;
        }
      }
    },
  },
  created: function () {
    // console.log(this,this.form_data);
    if (this.options) {
      this.init(this.options);
    }
  },
});
